const languageObj = {
  'Choose File': 'اختر ملف',
  'Please paste a URL': 'من فضلك الصق عنوان URL',
  'Loading': 'جار التحميل',
  'Analyzing': 'تحليل',
  'Try a sample': 'تجربة عينة',
  'Sorry, error occurs when analyzing the URL.': 'عذراً، حدث خطأ عند تحليل عنوان URL.',
  'Upload a photo': 'حمل الصورة',
  "Drag and drop files to the upload box.": 'اسحب الملفات وأفلتها في صندوق التحميل.',
  'Please select the proper position with portrait.': 'الرجاء تحديد الوضع المناسب مع عمودي.',
  'downloading':'جارى التحميل',
}

export default languageObj